import * as React from 'react';

import { Props } from './types';
import { arePropsEqual } from './utils';

const CloseIcon = React.memo(
  ({ className }: Props) => (
    <svg
      data-testid="close-icon"
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M5 5L19 19"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 5L5 19"
        strokeWidth="1.8"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  arePropsEqual
);

export default CloseIcon;
